import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
import cookie from "js-cookie";
export default {
  name: "popEnergy",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    ...userVuex.mapState(["userData"])
  },
  data() {
    return {};
  },
  props: {},
  watch: {
    "$parent.popFaceScanShow": {
      handler(newVal, oldVal) {
        if (!newVal && typeof oldVal !== 'undefined') {
          this.$parent.popFaceScanShow = false;
          //cookie.set("advTip:"+this.userData.id+":"+this.setting.popadv.id,true, { expires: 1/this.setting.popadv.pop_times })
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    async onSubmit() {
      this.$parent.popFaceScanShow = false;
      this.$nextTick(() => {
        if (this.$router.currentRoute.path != '/bioMatrixScan') {
          this.$router.push('/bioMatrixScan?hidden=1');
        }
      });
    }
  }
};